import React from "react";
import { Link } from "react-router-dom";
import "./LegalPage.css";

function LunicaAIPrivacy() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-header-content">
          <img src="/images/lunicaai_logo.png" alt="Lunica AI Logo" />
          <div>
            <h1>Lunica AI Privacy Policy</h1>
            <p>Intelligent Creative Companion</p>
          </div>
        </div>
        <Link to="/" className="legal-back-link">← Back to OnyxUp</Link>
      </div>

      <div className="legal-content">
          <h2>Privacy Policy</h2>
          <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          
          <h3>1. Introduction and Scope</h3>
          <p>Lunica AI ("we", "our", "us") values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and delete data when you use the Lunica AI app ("App").</p>
          
          <h3>2. User Eligibility</h3>
          <p>This App is intended for users aged 18 years and older. By using Lunica AI you confirm you meet this age requirement.</p>
          
          <h3>3. Information We Collect</h3>
          <p><strong>User Content:</strong></p>
          <ul>
            <li>Content you upload or create using the App is processed to provide AI-powered features.</li>
            <li>User-generated content is stored locally on your device or in your account (if the feature is provided) and remains under your control.</li>
            <li>We do not store your content beyond what is necessary to provide the service.</li>
          </ul>
          
          <p><strong>Technical & Usage Data:</strong></p>
          <ul>
            <li>We may collect anonymous, aggregated technical data (device model, OS version, app usage patterns) solely to improve performance and security.</li>
            <li>This does not include personally identifiable information.</li>
          </ul>
          
          <h3>4. Third-Party Processing and Retention</h3>
          <p>We may use trusted third-party services to process content and provide features (for example: AI model APIs, cloud storage services). All transfers use encrypted channels (HTTPS). Uploaded content is deleted from our systems and third-party processors within 24 hours after processing, unless you explicitly save it.</p>
          
          <h3>5. How We Use Your Information</h3>
          <p>We use collected information to provide, maintain, and improve App features, for security, and to comply with legal obligations. We do not sell or rent personal data to third parties.</p>
          
          <h3>6. Your Rights</h3>
          <p>You may request deletion of your data at any time by contacting us (see contact below). We will respond and process deletion requests within a reasonable timeframe and may ask for identity verification to honor the request.</p>
          
          <h3>7. Security</h3>
          <p>We implement reasonable technical and organizational measures to protect data. However, no system is completely secure; we cannot guarantee absolute security.</p>
          
          <h3>8. Changes to this Policy</h3>
          <p>We may update this Policy from time to time; material changes will be posted on this page with an updated "Last Updated" date.</p>
          
          <h3>9. Contact</h3>
          <p>For questions, data deletion requests or other inquiries, contact us at:</p>
          <p>📧 info@onyxup.net</p>
          
          <h3>10. Data Collection</h3>
          <p>The app processes user-uploaded content temporarily to generate AI-powered results and deletes it immediately after processing. No personal data is stored or shared without your explicit consent.</p>
          
          <h3>11. Privacy Policy URL</h3>
          <p>Privacy Policy URL: 🔗 <a href="https://www.onyxup.net/lunicaai/privacy">https://www.onyxup.net/lunicaai/privacy</a></p>
      </div>
    </div>
  );
}

export default LunicaAIPrivacy;



